import { kakaoSdkKey } from '@/constants/sdk'

declare const Kakao: any

export const init = () => {
  Kakao.init(kakaoSdkKey)
}

export const start = ({ name, x, y }: {
  name: string
  x: number
  y: number
}) => {
  Kakao.Navi.start({ name, x, y, coordType: 'wgs84' })
}
